/**
 * Botão grande de acionamento do PAEBM (D9).
 *
 * GUPM-221: acompanha a MESMA fonte do semáforo logo acima (nível ANM da
 * estrutura, já sem Observação). Enquanto lia só o pior instrumento, uma TARP de
 * emergência aberta pintava o semáforo de Emergência e deixava este botão apagado
 * — dois sinais contraditórios lado a lado, na tela onde a emergência é acionada.
 * Por isso recebe o mesmo `NivelAnmExibido`: se Observação acendesse o botão aqui
 * e não pintasse o semáforo, a contradição voltaria pelo outro lado.
 */
import type { NivelAnmExibido } from '@/domain/estrutura';

interface Props {
  status: NivelAnmExibido;
  onClick: () => void;
}

export default function EmergencyButton({ status, onClick }: Props) {
  const isActive = status !== 'NORMAL';
  return (
    <button
      onClick={onClick}
      className={`w-full mt-4 py-4 rounded-xl font-black text-base tracking-wide uppercase text-white transition-opacity ${isActive ? 'animate-pulse' : 'opacity-60'}`}
      style={{ background: isActive ? '#ef4444' : '#6b7280' }}
      aria-label="Acionar protocolo de emergência PAEBM"
    >
      🆘 Acionar protocolo de emergência (PAEBM)
    </button>
  );
}
